module.exports = __webpack_public_path__ + "img/top-vendor.4a6413e.svg";